import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tab-panel',
  template: '<div class="tab-content active" *ngIf="selected"><ng-content></ng-content></div>',
  standalone: true,
  imports: [CommonModule]
})
export class TabPanelComponent implements OnInit {

  @Output()
  public onClose = new EventEmitter();

  @Input()
  public name = '';

  @Input()
  public selected: boolean = false;

  @Input()
  public disabled = false;

  @Input()
  public showCloseBtn: boolean = false;

  @Input()
  public closeBtnTitle: string = 'Usuń zakładkę';

  @Input()
  public closeBtnDisabled = false;

  constructor() {
  }

  public ngOnInit(): void {
  }

}
